import { moduleConfig } from "@/core/config";
import { FirmwareItem } from "./interface";

export function getFirmwares(boxType: number): Promise<FirmwareItem[]> {
  const cfg = moduleConfig
  if (cfg.firmware && cfg.firmware.provider && cfg.firmware.provider.onFirmwaresLoad) {
    return cfg.firmware.provider.onFirmwaresLoad(boxType);
  }

  return fetch(`${cfg.firmware.url}/api/v4/se/firmware/list`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      boxType,
      isCompress: false,
      skipCount: 0,
      maxResultCount: 1000,
      seKey: cfg.firmware.secret
    })
  }).then(res => res.json()).then(x => Promise.resolve(x.items));
}
